var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H9M19 16H22V12.85C22.0007 12.6121 21.9165 12.3816 21.7625 12.2002C21.6085 12.0187 21.3949 11.8981 21.16 11.86L16 11L13.3 7.40005C13.2069 7.27585 13.0861 7.17505 12.9472 7.10562C12.8084 7.03619 12.6552 7.00005 12.5 7.00005H5.24C4.86727 6.99745 4.50123 7.09907 4.18318 7.29344C3.86513 7.4878 3.60772 7.76718 3.44 8.10005L2.64 9.73005C2.22015 10.5647 2.00099 11.4858 2 12.42V16H4M9 16.5C9 17.8808 7.88071 19 6.5 19C5.11929 19 4 17.8808 4 16.5C4 15.1193 5.11929 14 6.5 14C7.88071 14 9 15.1193 9 16.5ZM19 16.5C19 17.8808 17.8807 19 16.5 19C15.1193 19 14 17.8808 14 16.5C14 15.1193 15.1193 14 16.5 14C17.8807 14 19 15.1193 19 16.5Z",
    stroke: "#101010",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.5ab0ff6523abb937540cad95bdfedf1e.svg";
export { ForwardRef as ReactComponent };